import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {TextAlignedIcon} from './styles'

interface GuestLabelProps {
  /** Guest first name, from the booked room rather than the booker */
  firstName: string
  /** Guest last name, from the booked room rather than the booker */
  lastName: string
  /** Applies sold-out styling to visually indicate that the offer is no longer available. */
  isOfferSoldOut?: boolean
}

export const GuestLabel = ({
  firstName,
  lastName,
  isOfferSoldOut = false
}: GuestLabelProps) => {
  const colorPath = isOfferSoldOut
    ? 'content.neutral.disabled'
    : 'content.neutral.primary'

  return (
    <Box display="flex" gap="s250" alignItems="baseline" data-id="guest-label">
      <TextAlignedIcon name="UserCheck" size="sm" colorPath={colorPath} />
      <Text variant="bodyS" colorPath={colorPath} className="fs-mask">
        <FormattedMessageWrapper
          id="roomReservationDetails.names"
          defaultMessage="Reserved for {firstName} {lastName}"
          values={{firstName, lastName}}
        />
      </Text>
    </Box>
  )
}
